import { Breadcrumb, Button, Col, Form, Image, Input, Radio, Row, Steps, Switch, message } from "antd";
import "../sp.scss";
import "./prefactor.scss";
import { HomeOutlined } from "@ant-design/icons";
import { _adr } from "../../../../address";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import {
	complexDigitToman,
	convertPersian,
	convertToJalaliWithoutTime,
	fileToBase64,
	formatMsisdn,
	isEmpty,
	validateInput,
} from "../../../../tools/tools";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAPIPublic, useDealer } from "../../../../tools/api";
import PrintPrefactor from "../../../auxiliary/print/printPrefactor";
import IncressCharge from "../../../auxiliary/incressCharge/charge";
import { globalValue } from "../../../../reducer/serviceReducerGlobala";
import Loading from "../../../auxiliary/loader/loading";
import { useLayout } from "../../../layouts/layout";
import SPShopLayout from "../sp-shop-layout";
import { Roles, switchPlanID } from "../../../../tools/services";
const SpPreFactor = () => {
	const { setLayout } = useLayout();
	const [t] = useTranslation("global");
	const { calculateSPCommissionPrice, isValidDiscountCode, queryDiscountCodeByCode, queryMethodOfReceiptByPlanId, redirectToNeginWalletGateWay } =
		useDealer();
	const formData = useSelector((state) => state);

	const [frmReception] = Form.useForm();
	const dispatch = useDispatch();
	const nav = useNavigate();
	const [searchParam] = useSearchParams();
	const { queryTaxPercent } = useAPIPublic();
	const [messageApi, contextHolder] = message.useMessage();
	//show Image Upload
	const [isVisible, setIsVisible] = useState(false);

	const isDeliveryReception = formData?.another?._currentUser?.roles?.includes(Roles.Dealer_RegisterSim_Allow_Select_Method_Of_Receipt);

	//state show msisdn and gift
	const [msisdnList, setMsisdnList] = useState([]);
	const [giftChecked, setGiftChecked] = useState(true);

	const [profile, setProfile] = useState({});
	const [bundle, setBundle] = useState({});
	const [token, setToken] = useState("");
	const [fileDocument, setFileDocument] = useState("");
	//state tax percent
	const [wallet, setWallet] = useState(0);
	const [taxPercent, setTaxPercent] = useState(0);
	const [calcTax, setCalcTax] = useState(0);
	const [commission, setCommission] = useState(0);
	const [profit, setProfit] = useState(0);
	const [totalPay, setTotalPay] = useState(0);

	const [doDelete, setDoDelete] = useState(false);
	const [discount, setDiscount] = useState(0);
	const [isDiCount, setIsDiCount] = useState(false);
	const [discountCode, setDiscountCode] = useState("");
	const [percentDiscount, setPercentDiscount] = useState(0);
	const [maxDiscount, setMaxDiscount] = useState(0);
	const [totalDiscount, setTotalDiscount] = useState(0);

	const [isLoading, setIsLoading] = useState(false);
	const [localInvoiceId, setLocalInvoiceId] = useState("");
	const [bundleCommission, setBundleCommission] = useState("");
	const bankRef = useRef("");

	//method reception deliver
	const [receptionList, setReceptionList] = useState([]);
	const [selectReception, setSelectReception] = useState(385);
	const [priceReception, setPriceReception] = useState(0);

	// Incress Charge
	const [openIncress, setOpenIncress] = useState(false);

	const handleChange = (checked) => {
		try {
			setGiftChecked(checked);
			setMsisdnList(
				msisdnList.map((item) => {
					return { msisdn: item.msisdn, isgift: checked };
				}),
			);
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		const initialCheckState = async () => {
			try {
				if (!isEmpty(searchParam.get("localInvoiceId"))) {
					setMsisdnList(formData?.another?.spPurchase?.spMsisdn || []);
					setProfile(formData?.another?.spPurchase?.profile || {});
					// formData.from = formData?.another?.spPurchase;
					const fileDocument = await fileToBase64(formData?.another?.spPurchase?.profile?.photo);
					setBundle(formData?.another?.spPurchase?.spbundle || {});

					const getLocalInvoiceID = searchParam.get("localInvoiceId");
					setLocalInvoiceId(getLocalInvoiceID);
					setOpenIncress(true);

					setToken(formData?.another?.spPurchase?.token || "");
					setFileDocument(fileDocument || "");
				} else {
					setProfile(formData?.from?.spPurchase?.profile || formData?.another?.spPurchase?.profile || {});
					setMsisdnList(formData?.from?.spPurchase?.spMsisdn || formData?.another?.spPurchase?.spMsisdn || []);
					const fileDocument = await fileToBase64(formData?.from?.spPurchase?.profile?.photo || formData?.another?.spPurchase?.profile?.photo || "");
					setFileDocument(fileDocument || "");
					setBundle(formData?.from?.spPurchase?.spbundle || formData?.another?.spPurchase?.spbundle || {});
					setToken(formData?.from?.spPurchase?.token || formData?.another?.spPurchase?.token || "");
				}

				let payload = {
					planid: switchPlanID().simPurchase,
					cityid: profile?.cityid,
				};
				let resMethod = await queryMethodOfReceiptByPlanId(payload);
				if (resMethod) {
					const SelectedMethodReception = resMethod.find((item) => item.methodIsDefault);
					setReceptionList(resMethod);
					if (isDeliveryReception) {
						setSelectReception(SelectedMethodReception?.methodOfReceiptId);
					} else {
						setSelectReception(SelectedMethodReception?.methodOfReceiptId);
						setPriceReception(SelectedMethodReception?.costage);
					}
				}
			} catch (error) {
				console.error(error);
			}
		};
		initialCheckState();
	}, []);

	useEffect(() => {
		const CallInitialService = async () => {
			try {
				let response = await queryTaxPercent();
				if (response) {
					setTaxPercent(response);
				}
			} catch (error) {
				console.error(error);
			}
		};
		CallInitialService();
	}, []);

	useEffect(() => {
		setWallet(formData?.another?._currentUser?.walletAmount);
	}, [formData?.another?._currentUser?.walletAmount]);

	useEffect(() => {
		const CallAPI = async () => {
			try {
				if (Object.keys(bundle).length !== 0 && bundle.constructor === Object && msisdnList.length > 0) await handleCommission();
				if (taxPercent > 0) calculate();
			} catch (error) {
				console.error(error);
			}
		};
		CallAPI();
	}, [taxPercent, discountCode, receptionList, selectReception]);

	const handleCommission = async () => {
		try {
			let payload = {
				discountcode: discountCode ? discountCode : "",
				spbundleid: bundle.bundleSalesSimId,
				iccid: bundle.iccid,
				msisdn: msisdnList.length > 0 ? msisdnList[0]?.msisdn : 0,
				certno: profile?.certno,
			};
			let response = await calculateSPCommissionPrice(payload);
			if (response) {
				setCommission(response?.commission);
				setProfit(response?.packageSalesCommission);
				setBundleCommission(response?.bundleSalesCommission);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const calculate = () => {
		try {
			setIsLoading(true);
			let _bundlePrice = bundle.bundlePrice * msisdnList?.length,
				_totalDiscountOnPrice = 0,
				_taxPay = 0,
				_costagePost = receptionList?.length ? receptionList.find((item) => item.methodOfReceiptId === selectReception)?.costage : priceReception;

			setPriceReception(_costagePost);
			if (isDiCount) {
				_totalDiscountOnPrice = (_bundlePrice * percentDiscount) / 100;
				// if (maxDiscount > 0) {
				// 	setTotalDiscount(maxDiscount);
				// } else {
				// 	setTotalDiscount(_totalDiscountOnPrice);
				// }
				setTotalDiscount(maxDiscount);

				setDiscount(_totalDiscountOnPrice);
				if (_totalDiscountOnPrice > maxDiscount) {
					_totalDiscountOnPrice = _bundlePrice - maxDiscount;
					setDiscount(_totalDiscountOnPrice);
				} else {
					_totalDiscountOnPrice = _bundlePrice - _totalDiscountOnPrice;
				}
				_bundlePrice = _totalDiscountOnPrice;
			}
			_taxPay = ((_bundlePrice + _costagePost) * taxPercent) / 100;
			setCalcTax(_taxPay);

			let _totalPrice = _bundlePrice + _costagePost + _taxPay;

			setTotalPay(_totalPrice);

			// if (isDiCount) {
			//   let _totalDiscountOnPrice = (_totalPrice * percentDiscount) / 100;
			//   setTotalDiscount(_totalDiscountOnPrice);
			//   setDiscount(_totalDiscountOnPrice);
			//   if (_totalDiscountOnPrice > maxDiscount) {
			//     _totalDiscountOnPrice = _totalPrice - maxDiscount;
			//     setDiscount(_totalDiscountOnPrice);
			//   } else {
			//     _totalDiscountOnPrice = _totalPrice - _totalDiscountOnPrice;
			//   }
			//   setTotalPay(_totalDiscountOnPrice);
			// }
			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};

	//discount

	const handldeFrmDiscount = async (value) => {
		try {
			setIsLoading(true);
			if (doDelete) {
				setDoDelete(false);
				setIsDiCount(false);
				setDiscountCode(0);
				setPercentDiscount(0);
				setMaxDiscount(0);
			} else {
				let payload = {
					discountcode: value.discount,
					bundlesalessimid: bundle.bundleSalesSimId,
					certno: profile?.certno,
					planid: switchPlanID().simPurchase,
				};
				let resValid = await isValidDiscountCode(payload);
				if (resValid && !resValid.HasError) {
					payload = {
						discountcode: value.discount,
					};
					let response = await queryDiscountCodeByCode(payload);
					if (response) {
						setDoDelete(true);
						setIsDiCount(true);
						setDiscountCode(value.discount);
						setPercentDiscount(!isEmpty(response.inT_DiscountPercent) ? response.inT_DiscountPercent : 0);
						setMaxDiscount(!isEmpty(response.inT_MaxDiscountPrice) ? response.inT_MaxDiscountPrice : 0);
					}
				}
			}
			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};

	const handleCallBackCharge = (value) => {
		try {
			if (value?.length > 0) {
				// dispatch(clearFormData());
				dispatch(globalValue({ spPurchase: formData.from.spPurchase }));
				bankRef.current.innerHTML = value;
				document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
			} else {
				setLocalInvoiceId("");
				setOpenIncress(false);
			}
		} catch (error) {
			console.error(error);
		}
	};
	const handleSubmitPage = async () => {
		try {
			setIsLoading(true);
			if (wallet - Math.abs(commission) >= 0) {
				let payload = {
					planid: switchPlanID().simPurchase,
					cityid: profile?.cityid,
				};
				// let resMethod = await queryMethodOfReceiptByPlanId(payload);
				// if (resMethod) {
				// let methodOfReceiptId = resMethod[0].methodOfReceiptId;

				let count = 0;
				msisdnList.forEach((item) => {
					if (item.isgift) count++;
				});

				payload = {
					bundlesalessimgiftid: bundle?.bundleSalesSimGiftId,
					giftcount: count,
					certno: profile?.certno,
					methodreceiptid: selectReception,
					msisdn: msisdnList.map((item) => item.msisdn),
					iccid: bundle.iccid,
					planid: switchPlanID().simPurchase,
					bundlesalesimid: bundle.bundleSalesSimId,
					discountcode: discountCode,
				};
				let response = await redirectToNeginWalletGateWay(payload);
				if (response) {
					nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Document, {
						state: response,
					});
				} else {
				}
				// }
			} else {
				messageApi.open({
					type: "error",
					content: "موجودی کیف پول کافی نمی باشد.",
				});
			}
			setIsLoading(false);
		} catch (error) {
			console.error(error);
			setIsLoading(false);
		}
	};

	useEffect(() => {
		setLayout(
			<PrintPrefactor
				titlePage="پیش‌فاکتور فروش سیم‌کارت"
				listPrint={[
					{
						label: <>سیم‌کارت + بسته آغازین</>,
						value: (
							<>
								<span dir="ltr">{complexDigitToman(bundle?.bundlePrice)}</span> تومان
							</>
						),
					},
					{
						label: <>مالیات ({taxPercent}درصد)</>,
						value: (
							<>
								<span dir="ltr">{complexDigitToman(calcTax)} </span> تومان
							</>
						),
					},
					isDiCount && {
						label: (
							<>
								تخفیف <span>({percentDiscount} درصد)</span>
							</>
						),
						value: (
							<>
								<span dir="ltr">{complexDigitToman(discount)} </span>تومان
							</>
						),
					},
					{
						label: "مبلغ قابل دریافت از مشتری",
						value: (
							<>
								<span dir="ltr">{complexDigitToman(totalPay)} </span>تومان
							</>
						),
					},
					{
						label: "مبلغ برداشت از کیف پول",
						value: (
							<>
								<span dir="ltr">{complexDigitToman(Math.abs(commission))} </span> تومان
							</>
						),
					},
					// {
					//   label: "سود شما از این فروش",
					//   value: (
					//     <>
					//       <span dir="ltr">{complexDigitToman(commission)} </span> تومان
					//     </>
					//   ),
					// },
					{
						label: "مجموع",
						value: (
							<>
								<span dir="ltr">{complexDigitToman(totalPay)}</span>
							</>
						),
					},
				]}
			/>,
		);
	}, []);

	return (
		<>
			<SPShopLayout>
				{contextHolder}

				<div className="g-hold-title-of-page">
					<Breadcrumb
						className="breadcrumbs"
						items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("simcardpurchase.global.title") }]}
					/>
					<div className="title-page">
						<h3>{t("simcardpurchase.global.title")}</h3>
						<p>{t("simcardpurchase.global.decription")}</p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className="g-layout-main sp-container">
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className="g-format-steps">
									<div className="holder-step">
										<Steps
											size="small"
											className="step-wizard"
											current={3}
											items={[
												{
													title: "بسته آغازین",
												},
												{
													title: "انتخاب شماره",
												},
												{
													title: "اطلاعات هویتی",
												},
												{
													title: "پیش فاکتور",
												},
												{
													title: "سند",
												},
											]}
										/>
									</div>
								</div>
								<div className="g-prefactor">
									<div className="holder-row-prefactor">
										<Row gutter={16}>
											<Col span={14} xl={14} lg={14} md={24} sm={24} xs={24}>
												<div className="for-pay-client">
													<h3 className="header-of-form">صورت حساب مشتری</h3>
													<div className="holder-box">
														<div className="holder-simcard">
															<div className="holder-list-msisdn">
																{msisdnList.map((item, key) => (
																	<div key={key}>
																		<div className="item">
																			<div className="row-item">
																				<div className="holder-icon">
																					<i className="icon-simcard"></i>
																				</div>
																				<div className="holder-text">
																					<h4>
																						{bundle?.bundleName} <span dir="ltr">{formatMsisdn(item.msisdn)}</span>
																					</h4>
																					<p>
																						{bundle?.attribute?.map((item, key) => (
																							<React.Fragment key={key}>{item.briefDescription} </React.Fragment>
																						))}
																					</p>
																				</div>
																				<div className="holder-option"></div>
																			</div>
																		</div>
																		{item.isgift && bundle?.bundleSalesSimGiftId?.length > 0 && (
																			<div className="item gift">
																				<div className="row-item">
																					<div className="holder-icon">
																						<i className="icon-gift-box"></i>
																					</div>
																					<div className="holder-text">
																						<h4>سیم کارت هدیه</h4>
																						{/* <p>به همراه 2 گیگ اینترنت رایگان یک ماهه + 50 دقیقه مکالمه</p> */}
																					</div>
																				</div>
																			</div>
																		)}
																	</div>
																))}
															</div>
															<div className="holder-gift">
																<div className="holder-option">
																	{bundle?.bundleSalesSimGiftId?.length > 0 && (
																		<Switch className="switch-gift" checked={giftChecked} onChange={handleChange} />
																	)}
																</div>
															</div>
														</div>
														<div className="divider"></div>
														<div className="holder-profile">
															<h4>
																اطلاعات هویتی{" "}
																<Link to={_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Profile}>
																	<i className="icon-edit"></i>
																</Link>
															</h4>
															<div className="list-item">
																<div className="item">
																	<div className="label">نام:</div>
																	<div className="value">{profile?.fname}</div>
																</div>
																<div className="item">
																	<div className="label">نام خانوادگی:</div>
																	<div className="value">{profile?.lname}</div>
																</div>
																<div className="item">
																	<div className="label">کد ملی:</div>
																	<div className="value">{profile?.certno}</div>
																</div>
																<div className="item">
																	<div className="label">تاریخ تولد:</div>
																	<div className="value">{convertToJalaliWithoutTime(profile?.birthdate)}</div>
																</div>
																<div className="item">
																	<div className="label">نام پدر:</div>
																	<div className="value">{profile?.fathername}</div>
																</div>
																<div className="item">
																	<div className="label">شماره شناسنامه:</div>
																	<div className="value">{profile?.identityno}</div>
																</div>
																<div className="item">
																	<div className="label">جنسیت:</div>
																	<div className="value">{profile?.txtGender}</div>
																</div>
																<div className="item">
																	<div className="label">موبایل:</div>
																	<div className="value" dir="ltr">
																		0{formatMsisdn(profile?.smsmobileno?.slice(1))}
																	</div>
																</div>
																<div className="item">
																	<div className="label">تصویر کارت ملی:</div>
																	<div className="value">
																		<div className="show-document">
																			<Button onClick={() => setIsVisible(true)} type="link">
																				بارگذاری شده
																			</Button>
																			<Image
																				preview={{
																					visible: isVisible,
																					onVisibleChange: (value) => setIsVisible(value),
																				}}
																				src={fileDocument}
																				style={{ display: "none" }}
																			/>
																		</div>
																	</div>
																</div>
															</div>
														</div>
														<div className="divider"></div>
														<div className="holder-profile">
															<h4>اطلاعات آدرس</h4>
															<div className="list-item">
																<div className="item">
																	<div className="label">استان:</div>
																	<div className="value">{profile?.txtProvince}</div>
																</div>
																<div className="item">
																	<div className="label">شهر:</div>
																	<div className="value">{profile?.txtCity}</div>
																</div>
																<div className="item">
																	<div className="label">خیابان اصلی:</div>
																	<div className="value">{profile?.mainstreet}</div>
																</div>
																<div className="item">
																	<div className="label">خیابان فرعی:</div>
																	<div className="value">{profile?.auxiliaryroad}</div>
																</div>
																<div className="item">
																	<div className="label">کوچه:</div>
																	<div className="value">{profile?.alley}</div>
																</div>
																<div className="item">
																	<div className="label">پلاک:</div>
																	<div className="value">{profile?.buildingno}</div>
																</div>
																<div className="item">
																	<div className="label">طبقه:</div>
																	<div className="value">{profile?.floor}</div>
																</div>
																<div className="item">
																	<div className="label">واحد:</div>
																	<div className="value">{profile?.unit}</div>
																</div>
																<div className="item">
																	<div className="label">کدپستی:</div>
																	<div className="value">{profile?.postalcode}</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</Col>
											<Col span={10} xl={10} lg={10} md={24} sm={24} xs={24}>
												<div className="for-pay-agent">
													<h3 className="header-of-form">صورت حساب فروشنده</h3>
													<div className="holder-box">
														{isDeliveryReception && (
															<div className="holder-delivery">
																<h3>روش ارسال</h3>
																<div className="deliverymethod">
																	{receptionList?.length > 0 && (
																		<Radio.Group
																			className="holdDeliveryMethod"
																			value={selectReception}
																			onChange={(e) => {
																				setSelectReception(e.target.value);
																			}}
																			defaultValue={selectReception}>
																			{receptionList.map((item, key) => (
																				<Radio
																					checked={item.methodOfReceiptId === selectReception ? true : false}
																					key={key}
																					value={item.methodOfReceiptId}>
																					<div className="holder-item">
																						<div className="row-item">
																							<div className="hold-title">
																								<h4>{item.description}</h4>
																								{item.costage > 0 && <span>({complexDigitToman(item.costage)} تومان)</span>}
																							</div>
																							<div className="hold-icon">
																								{item.methodOfReceiptId === 385 ? (
																									<img src={process.env.PUBLIC_URL + "/assets/images/post.png"} alt="" />
																								) : (
																									<img src={process.env.PUBLIC_URL + "/assets/images/emam-khomeini.png"} alt="" />
																								)}
																							</div>
																						</div>
																					</div>
																				</Radio>
																			))}
																		</Radio.Group>
																	)}
																</div>
															</div>
														)}

														<div className="holder-form-dicount">
															<Form
																layout="vertical"
																onFinish={handldeFrmDiscount}
																initialValues={{
																	deleted: doDelete,
																}}>
																<Form.Item label="کد تخفیف" name="discount" rules={[validateInput({ t: t, validate: true })]}>
																	<Input
																		autoComplete="off"
																		onChange={(e) => (e.target.value = convertPersian(e.target.value))}
																		suffix={
																			<Button htmlType="submit" className="btn-normal btn-aptel">
																				{isDiCount ? <>حذف</> : <>اعمال</>}
																			</Button>
																		}
																		maxLength="32"
																	/>
																</Form.Item>
															</Form>
														</div>
														<div className="holder-list-pay">
															<ul>
																<li>
																	<div className="label">سیم‌کارت + بسته آغازین</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(bundle?.bundlePrice)}</span> <small>تومان</small>
																	</div>
																</li>

																{isDiCount && (
																	<li>
																		<div className="label">
																			تخفیف{" "}
																			<span>
																				({percentDiscount} درصد {maxDiscount > 0 && <> سقف {complexDigitToman(totalDiscount)} تومان</>})
																			</span>
																		</div>
																		<div className="value">
																			<span dir="ltr">{complexDigitToman(totalDiscount)}</span> تومان
																		</div>
																	</li>
																)}

																{isDeliveryReception && (
																	<>
																		<li>
																			<div className="label">هزینه ارسال</div>
																			<div className="value">
																				<span dir="ltr">{complexDigitToman(priceReception)}</span> تومان
																			</div>
																		</li>
																	</>
																)}
																<li>
																	<div className="label">مالیات ({taxPercent}درصد)</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(calcTax)}</span> تومان
																	</div>
																</li>
																<li>
																	<div className="label">مبلغ قابل دریافت از مشتری</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(totalPay)}</span> تومان
																	</div>
																</li>
																<li>
																	<div className="label">{commission > 0 ? <> مبلغ واریز به کیف پول</> : <>مبلغ برداشت از کیف پول</>}</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(Math.abs(commission))}</span> تومان
																	</div>
																</li>
																<li>
																	<div className="label">سود شما از این فروش</div>
																	<div className="value">
																		<span dir="ltr">{complexDigitToman(profit + bundleCommission)} </span> تومان
																	</div>
																</li>
															</ul>
															{wallet - Math.abs(commission) >= 0 || commission > 0 ? (
																<div className="hold-message success">
																	<p> {commission > 0 ? <> این مبلغ به کیف پول شما واریز می‌شود</> : <>این مبلغ از کیف پول شما برداشت می‌شود</>}</p>
																	<h3>
																		{" "}
																		<span dir="ltr">{complexDigitToman(Math.abs(commission))}</span> تومان
																	</h3>
																</div>
															) : (
																<div className="hold-message error">
																	<div className="row-message">
																		<div className="holder-text">
																			<h3>اعتبار شما کافی نمی‌باشد</h3>
																			<ul>
																				<li>
																					<div className="label">کسری اعتبار: </div>
																					<div className="value">
																						<span dir="ltr">{complexDigitToman(Math.abs(wallet + commission))} </span> تومان
																					</div>
																				</li>
																			</ul>
																		</div>
																		<div className="holder-acction">
																			<div className="holder-button">
																				<Button className="btn-normal btn-aptel" htmlType="button" onClick={() => setOpenIncress(true)}>
																					افزایش اعتبار
																				</Button>
																			</div>
																		</div>
																	</div>
																</div>
															)}

															{/* <div className="hold-message error">
																<div className="row-message">
																	<div className="holder-text">
																		<h3>اعتبار شما کافی نمی‌باشد</h3>
																		<ul>
																			<li>
																				<div className="label">کسری اعتبار: </div>
																				<div className="value">
																					<span dir="ltr">{complexDigitToman(Math.abs(wallet + commission))} </span> تومان
																				</div>
																			</li>
																		</ul>
																	</div>
																	<div className="holder-acction">
																		<div className="holder-button">
																			<Button className="btn-normal btn-aptel" htmlType="button" onClick={() => setOpenIncress(true)}>
																				افزایش اعتبار
																			</Button>
																		</div>
																	</div>
																</div>
															</div> */}
														</div>
													</div>
												</div>
											</Col>
										</Row>
									</div>
								</div>
							</div>
							<div className="g-footer-format-page">
								<div className="row-button">
									<div className="holder-button">
										{/* <Button
                      onClick={() => {
                        window.print();
                      }}
                      className="btn-normal btn-print"
                      type="default"
                      icon={<i className="icon-print"></i>}
                    >
                      چاپ پیش‌فاکتور
                    </Button> */}
									</div>
									<div className="holder-button">
										<Button className="btn-normal btn-aptel" type="primary" danger onClick={handleSubmitPage}>
											مرحله بعد
										</Button>
										<Button
											className="btn-normal"
											onClick={() => {
												nav(_adr.Root + _adr.SimCardPurchase.Index + _adr.SimCardPurchase.Profile);
											}}
											type="default">
											بازگشت
										</Button>
									</div>
								</div>
							</div>
						</div>
					</Content>
				</div>
				<IncressCharge
					open={openIncress}
					planid={process.env.REACT_APP_PLANID_CHARGE_WALLET_SP}
					msisdn={formData?.another?._currentUser?.telnoone}
					price={Math.abs(commission)}
					callback={handleCallBackCharge}
					localInvoiceId={localInvoiceId}
				/>

				<Loading isOpen={isLoading} />
				<div ref={bankRef}></div>
			</SPShopLayout>
		</>
	);
};

export default SpPreFactor;
